import jsPDF from 'jspdf';
import { formatNumber } from 'helpers';

export const getBankDepositDetails = ({ bank, amount, invoiceCode }) => ({
  title: 'Dépôt bancaire',
  instruction: 'Rendez vous dans une agence pour effectuer le dépôt.',
  bankName: bank?.name,
  bankDescription: bank?.description,
  amountLabel: 'Montant à déposer',
  amount: `${formatNumber(amount)} FCFA`,
  invoiceLabel: 'Numéro de facture à communiquer',
  invoiceCode: String(invoiceCode),
});

const drawField = (pdf, label, value, y, fontSize) => {
  pdf.setFont('helvetica', 'normal');
  pdf.setFontSize(9);
  pdf.setTextColor(32, 45, 40);
  pdf.text(label, 18, y);
  pdf.setFillColor(255, 255, 255);
  pdf.setDrawColor(205, 217, 209);
  pdf.roundedRect(18, y + 5, 112, 22, 2, 2, 'FD');
  pdf.setFont('helvetica', 'bold');
  pdf.setFontSize(fontSize);
  pdf.text(value, 23, y + 19);
};

export const downloadBankDepositPdf = (details) => {
  const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a5' });
  const pdfAmount = details.amount.replace(/[\u00a0\u202f]/g, ' ');

  pdf.setFillColor(255, 255, 255);
  pdf.rect(0, 0, 148, 210, 'F');
  pdf.setFont('helvetica', 'bold');
  pdf.setFontSize(10);
  pdf.setTextColor(45, 125, 82);
  pdf.text('INSTRUCTIONS DE DÉPÔT', 10, 16);
  pdf.setFont('helvetica', 'normal');
  pdf.setFontSize(9);
  pdf.setTextColor(105, 115, 110);
  pdf.text(`Facture ${details.invoiceCode}`, 10, 25);
  pdf.setDrawColor(45, 125, 82);
  pdf.setLineWidth(0.8);
  pdf.line(10, 32, 138, 32);

  pdf.setFillColor(232, 240, 236);
  pdf.roundedRect(10, 40, 128, 146, 3, 3, 'F');
  pdf.setFont('helvetica', 'bold');
  pdf.setFontSize(16);
  pdf.setTextColor(32, 45, 40);
  pdf.text(details.title, 18, 55);
  pdf.setFont('helvetica', 'normal');
  pdf.setFontSize(9);
  pdf.setTextColor(105, 115, 110);
  pdf.text(details.instruction, 18, 65);

  pdf.setFillColor(255, 255, 255);
  pdf.setDrawColor(205, 217, 209);
  pdf.roundedRect(18, 74, 112, 29, 2, 2, 'FD');
  pdf.setDrawColor(45, 125, 82);
  pdf.setLineWidth(0.6);
  pdf.line(25, 86, 35, 86);
  pdf.line(26, 85, 30, 82);
  pdf.line(30, 82, 34, 85);
  pdf.line(27, 87, 27, 93);
  pdf.line(30, 87, 30, 93);
  pdf.line(33, 87, 33, 93);
  pdf.line(25, 94, 35, 94);
  pdf.setFont('helvetica', 'bold');
  pdf.setFontSize(11);
  pdf.setTextColor(32, 45, 40);
  pdf.text(details.bankName, 41, 86);
  pdf.setFont('helvetica', 'normal');
  pdf.setFontSize(8);
  pdf.setTextColor(105, 115, 110);
  pdf.text(details.bankDescription, 41, 93);

  drawField(pdf, details.amountLabel, pdfAmount, 114, 14);
  drawField(pdf, details.invoiceLabel, details.invoiceCode, 152, 12);
  pdf.save(`Facture ${details.invoiceCode}.pdf`);
};
